// AwardsSection.jsx
import React , {useState} from "react";
import "../../css/awards.css";
import { AwardCard } from "./AwardCard";
import { Navbar } from "./Navbar";
import a1 from '../../images/awa-2.webp'
import a2 from '../../images/awa-1.webp'
import a3 from '../../images/awa-3.webp'
import a4 from '../../images/awa-4.webp'
import a5 from '../../images/awa-5.webp'
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';

const awards = [
  {
    title: "STAR PLAYER OF RADIANCE",
    // subtitle: "Visual Appeal",
    company: "RADIANE REALTY",
    image: a1,
    
  },
  {
    title: "FOR CONSISTENTLY DELIVERING THE HIGHEST NUMBER OF SUCCESSFUL DEALS",
    // subtitle: "User Experience",
    company: "STONE & ACRES.",
    image: a2,
   
  },
   {
    title: "BEST SITE VISTE PERFORMER",
    // subtitle: "User Experience",
    company: "KPN PROMOTERS",
    image: a3,
  },
   {
    title: "FOR THEIR CONSISTENT HIGH PERFORMANCE AND SUPPORT IN ACHIEVING OUR MILESTONES",
    // subtitle: "User Experience",
    company: "PURVA SOUKHYAM",
    image: a4,
  },
   {
    title: "PRESENTED TO VALUED PARTNER",
    // subtitle: "User Experience",
    company: "GRAND MAGNUM",
    image: a5,
  }      
];


export const AwardsSection = () => {

  const [openAward, setOpenAward] = useState(false);
  const [awardIndex, setAwardIndex] = useState(0);

  const awardSlides = awards.map((award) => ({
    src: award.image,
    title: award.title,
  }));

  const handleImageClick = (index) => {
    setAwardIndex(index);
    setOpenAward(true);
  };


  return (
    <div>
        <Navbar />
   <div className="margin"></div>
         <section className="awards-section">
      <div className="awards-header">
        <h2>Top Award-Winning Real Estate Agency in Chennai</h2>
        <p>
          Experience only the best Award Winning Service from the Top 5 Real Estate Agency in Chennai. 
          24k Realtors is the top award-winning Real Estate Agency in Chennai, India. Our team of agents has 
          been recognized for excellence in service and satisfaction. We are committed to providing the best 
          experience possible for our clients, and we have been awarded for our achievements.
        </p>
      </div>

      <h3 className="awards-title">Awards received by 24k Realtors team</h3>

      <div className="awards-grid">
          {awards.map((award, index) => (
      <AwardCard award={award} index={index} key={index}   onImageClick={handleImageClick} />
        ))}
         {awardSlides.length > 0 && (
        <Lightbox
          open={openAward}
          close={() => setOpenAward(false)}
          index={awardIndex}
          slides={awardSlides}
          plugins={[Zoom, Thumbnails]}
        />
      )}
      </div>
    </section></div>
  )
}
